<template>
  <div
    class="guestbook-navigation"
    :style="{ backgroundColor: stylingNavigationBackgroundColor }"
  >
    <div class="guestbook-navigation__header">
      <div 
        class="guestbook-navigation__header__language-container"
      >
        <button
          v-if="languageTypes.length > 1"
          :style="{
            backgroundColor: stylingNavigationBackgroundColor,
            borderColor: stylingNavigationTextColor,
            color: stylingNavigationTextColor,
          }"
        >
          <div class="guestbook-country">
            <img :src="selectedCountryFlag" alt="img" class="guestbook-country__flag__image" />
            <div class="guestbook-navigation__country-code-wrapper">
              <p>{{ selectedLanguageIso }}</p>
              <v-icon
                name="caret-down"
                scale="1"
                :style="{ color: stylingNavigationTextColor }"
              ></v-icon>
            </div>
          </div>
          <div class="guestbook-navigation__header__language-container__dropdown">
            <!-- DYNAMIC LANGUAGES -->
            <div v-for="({ nativeName, countryCode, countryFlag }, index) in languageTypes" :key="index">
              <div
                class="guestbook-navigation__header__language-container__dropdown__button-container"
                @click="() => switchLanguage(countryCode)"
              >
                <input
                  type="radio"
                  name="language"
                  :checked="currentActiveCountryCode === countryCode"
                />
                <img :src="countryFlag" alt="img" class="guestbook-country__flag__image" />
                <p>{{ nativeName }}</p>
              </div>
            </div>
            <!-- END OF DYNAMIC LANGUAGES -->
          </div>
        </button>
      </div>
      <div class="guestbook-navigation__header__logo-container">
        <div class="expander"></div>
        <img :src="stylingNavigtaionLogoPath" />
      </div>
      <div 
        class="guestbook-navigation__header__nav-button-container"
      >
        <div
          :style="{ color: stylingNavigationTextColor }"
          @click="toggleNavigationActive"
          v-if="navigationLinks && navigationLinks.length"
        >
          <div class="hamburger-icon">
            <span
              class="hamburger-icon__bar"
              :style="{ backgroundColor: stylingNavigationTextColor }"
            ></span>
            <span
              class="hamburger-icon__bar"
              :style="{ backgroundColor: stylingNavigationTextColor }"
            ></span>
            <span
              class="hamburger-icon__bar"
              :style="{ backgroundColor: stylingNavigationTextColor }"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="guestbook-navigation__navigation" v-if="isNavigationActive">
      <div class="guestbook-navigation__navigation__wrapper">
        <div
          class="guestbook-navigation__navigation__item"
          v-for="link in navigationLinks"
          :key="link.url"
          @click="clickFire(link.text, link.path)"
        >
          <span v-if="isLanguageSecond && languageCookie">{{
            link.textSec
          }}</span>
          <span v-else>{{ link.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cookieMixin from "@/mixins/cookieMixin";
import { trackBehavior } from "../callables";
import { db } from '@/firebase';
import newLanguageTypesFormatMixin from '@/mixins/newLanguageTypesFormatMixin';

export default {
  mixins: [cookieMixin, newLanguageTypesFormatMixin],
  data() {
    return {
      customerID: '',
      languageTypes: [],
      stylingNavigationBackgroundColor: "",
      stylingNavigationTextColor: "",
      stylingNavigtaionLogoPath: "",
      isLanguageSecond: false,
      currentActiveCountryCode: null,
      countryCodeSecond: "",
      languageNativeNameDefault: "",
      languageNativeNameSecond: "",
      navigationLinks: [],
      isNavigationActive: false,
    };
  },
  computed: {
    languageCookie() {
      if (this.getCookie("secondLanguage")) {
        return true;
      } else {
        return false;
      }
    },
    selectedLanguageIso() {
      return this._getActiveLanguege().countryCode;
    },
    selectedCountryFlag() {
      return this._getActiveLanguege().countryFlag;
    }
  },
  watch: {
    $route: "fetchNavigationData",
  },
  mounted() {

    this.fetchNavigationData();

    if (window.matchMedia("(min-width: 1020px)").matches) {
      this.activeDesktopView = true;
    } else {
      this.activeDesktopView = false;
    }

    const activeLanguage = this.getCookie('activeLanguage');

    if (activeLanguage) {
      this.currentActiveCountryCode = activeLanguage;
    } else {
      if(this.languageTypes.length) {
        this.setCookie('activeLanguage', this.languageTypes[0].countryCode);
      }
    }
  },
  methods: {
    _getActiveLanguege() {
      const activeLanguage = this.getCookie('activeLanguage');

      if (!activeLanguage) {
        return this.languageTypes[0];
      }

      const index = this.languageTypes.findIndex(({ countryCode }) => countryCode === activeLanguage);

      if (index >= 0) {
        return this.languageTypes[index];
      }

      return this.languageTypes[0];
    },
    async fetchNavigationData() {
      if (this.$route.params.hotel) {

        this.languageTypes = await this._getCorrectEventLanguages(this.$customerId);

        let navigationData = db.ref(`hotels/${this.$customerId}/${this.$hotelId}/nav`).once("value");
        let navigationLinksData = db.ref(`hotels/${this.$customerId}/${this.$hotelId}/links`).once("value")

        let [navigationDataSnap, navigationLinksDataSnap] = await Promise.all([navigationData, navigationLinksData]);

        let stylingNavigation = navigationDataSnap.val();
        this.stylingNavigationBackgroundColor = stylingNavigation.bgColor;
        this.stylingNavigationTextColor = stylingNavigation.textColor;
        this.stylingNavigtaionLogoPath = stylingNavigation.logoPath;
        this.$emit(
          "appBackgroundColor",
          stylingNavigation.guestbookBodyColor
        );
        this.navigationLinks = navigationLinksDataSnap.val();
      }
    },
    toggleNavigationActive() {
      this.isNavigationActive = !this.isNavigationActive;
    },
    switchLanguage(languageClicked) {
      this.setCookie('activeLanguage', languageClicked);
      this.$router.go();
    },
    clickFire(titleText, toPath) {
      var activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
      if (activeGuestTemp && activeGuestTemp !== "testView") {
        trackBehavior({
          action: "click",
          clickedInfo: titleText,
          guestID: activeGuestTemp,
          eventID: this.$hotelId,
          customerID: this.$customerId,
        });
      }
      this.toggleNavigationActive();
      this.$router.push(toPath);
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.guestbook-country {
  display: flex;
  align-items: center;
  position: relative;
  right: 45px;
}
.guestbook-country .guestbook-navigation__country-code-wrapper {
  display: flex;
  align-items: center;
  padding-right: 25px;
}
.guestbook-country__flag__image {
  width: 40px;
  height: 28px;
  margin-right: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.guestbook-navigation {
  height: 70px;
}
.guestbook-navigation__header,
.guestbook-navigation__header__language-container,
.guestbook-navigation__header__logo-container,
.guestbook-navigation__header__nav-button-container {
  /* all containers under main navigation */
  height: 100%;
}
.guestbook-navigation__header {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.guestbook-navigation__header__language-container,
.guestbook-navigation__header__nav-button-container {
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.guestbook-navigation__header__language-container button {
  border: none;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  text-transform: uppercase;
}
.guestbook-navigation__header__language-container button p {
  display: inline-block;
  margin-right: 5px;
}
.guestbook-navigation__header__language-container__dropdown {
  display: none;
  position: absolute;
  z-index: 1;
  background-color: white;
  margin-left: 10px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  max-height: 18rem;
  overflow-y: auto;
}
.guestbook-navigation__header__language-container__dropdown:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -6px;
  left: 15px;
  width: 12px;
  height: 12px;
  background-color: white;
  transform: rotate(45deg);
}
.guestbook-navigation__header__language-container__dropdown__button-container {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: white;
  color: #aaaaaa;
  text-transform: capitalize;
  text-align: left;
}
.guestbook-navigation__header__language-container__dropdown__button-container:first-child {
  border-radius: 8px 8px 0 0;
}
.guestbook-navigation__header__language-container__dropdown__button-container:last-child {
  border-radius: 0 0 8px 8px;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  p {
  margin: 0;
}
.guestbook-navigation__header__language-container
  button:hover
  .guestbook-navigation__header__language-container__dropdown {
  display: block;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  input {
  visibility: hidden;
  position: absolute; /* Do not take up space for other items */
}
.guestbook-navigation__header__language-container__dropdown__button-container
  .radio-button-custom {
  width: 25px;
  height: 25px;
  border: 4px solid #aaaaaa;
  border-radius: 50%;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.guestbook-navigation__header__language-container__dropdown__button-container:hover {
  color: #999999;
  background-color: #eeeeee;
}
.guestbook-navigation__header__language-container__dropdown__button-container:hover
  .radio-button-custom {
  border-color: #999999;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  .radio-button-custom__checkmark {
  display: none;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: black;
}
.guestbook-navigation__header__language-container__dropdown__button-container
  input:checked
  ~ .radio-button-custom
  .radio-button-custom__checkmark {
  /* When input is checked, change sibling */
  display: block;
}
.guestbook-navigation__header__logo-container {
  padding: 5px 5px;
  display: flex;
  align-items: center;
}
.guestbook-navigation__header__logo-container img {
  max-height: 100%;
  max-width: 100%;
}
.hamburger-icon {
  width: auto;
}
.hamburger-icon .hamburger-icon__bar {
  display: block;
  content: "";
  width: 25px;
  height: 2px;
}
.hamburger-icon .hamburger-icon__bar:first-child {
  margin-bottom: 5px;
}
.hamburger-icon .hamburger-icon__bar:last-child {
  margin-top: 5px;
}
.guestbook-navigation__navigation {
  background-color: white;
  position: relative;
  z-index: 1;
}
.guestbook-navigation__navigation__item {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dddddd;
  cursor: pointer;
}

@media screen and (min-width: 1040px) {
  .guestbook-navigation__header {
    justify-content: flex-end;
  }
  .guestbook-navigation__header__logo-container {
    margin-right: auto;
  }
  .guestbook-navigation__header__language-container,
  .guestbook-navigation__header__nav-button-container {
    order: 1;
  }
  .guestbook-navigation__header__language-container__dropdown {
    right: 0;
  }
  .guestbook-navigation__navigation__wrapper {
    max-width: 1000px;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
  }
  .guestbook-navigation__navigation__item {
    border-bottom: none;
    border-right: 1px solid #dddddd;
    padding: 0 20px;
    height: 50px;
    user-select: none;
  }
  .guestbook-navigation__navigation__item:first-child {
    border-left: 1px solid #dddddd;
  }
}
</style>